module.exports = __webpack_public_path__ + "static/img/sh.9ac54f82.png";